// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"02242aed","132":"297e671c","134":"5e82f6ac","259":"61cea080","334":"631a5df2","453":"6ee8af89","458":"b89119fa","787":"e5ee1f32"}[chunkId] + ".chunk.js";
};